import React from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import SubmenuWarehouse from '../submenu/SubmenuWarehouse'
import PackingGoodsForm from './form/PackingGoodsForm'

const PackingGoods = () => {
  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuWarehouse />
		</MyBlock>
        <MyBlockHeader
            header={'Пакування товарів в партію'}
            // isBack={true}
            // options={
            //     <FactoryOneOptions 
            //         factoryId={id}
            //     />
            // }
        />
        {/* <MyBlock>
            <BoxOneOptions 
                boxId={boxId}
            />
        </MyBlock> */}
		<MyBlock>
            <PackingGoodsForm />
		</MyBlock>
    </LayoutMain>
  )
}

export default PackingGoods